import { environment } from '@environments/environment';

export const GET_STORES_BY_AREA_QUERY = (langcode: string, type: 'region' | 'dept' | 'all', area: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_store,
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            exists: {
              field: 'uuid',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          ...(type !== 'all' && (type === 'dept' || type === 'region')
            ? [
                {
                  term: {
                    ...(type === 'dept' && { departement: area }),
                    ...(type === 'region' && { region: area }),
                  },
                },
              ]
            : []),
        ],
      },
    },
    sort: [
      {
        title: {
          order: 'asc',
        },
      },
    ],
  },
});
